export const SYSTEM_FORMAT_DATA = {
  EMAIL_FORMAT: '[a-zA-Z0-9_\.\+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-\.]+',
  PHONE_FORMAT: '^[ ]*((\\84)|0)([0-9]{9,10})[ ]*',
  FLOAT_FORMAT: '[^.]*([.](.{1,2}))?',
  NUMBER_FORMAT: '[^.]+',
};

export enum MomentDateFormat {
  DATE = 'DD/MM/YYYY',
  DATE_TIME = 'DD/MM/YYYY HH:mm:ss',
  DATE_TIME_MINUTE = 'DD/MM/YYYY HH:mm',
  DATE_TIME_MILLISECONDS = 'YYYYMMDDHHmmssSSS',
  MONTH_YEAR = 'MM/YYYY',
  YEAR = 'YYYY'
}

export enum SysDateFormat {
  DATE = 'dd/MM/yyyy',
  DATE_TIME = 'dd/MM/yyyy HH:mm:ss',
  DATE_TIME_MINUTE = 'dd/MM/yyyy HH:mm',
  DATE_MILLISECONDS = 'yyyyMMddHHmmssSSS',
  MONTH_YEAR = 'MM/yyyy',
  YEAR = 'yyyy'
}
